module.exports = __webpack_public_path__ + "img/search.c78ee985.png";